import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=661012f0"
import script from "./ServiceProviderList.vue?vue&type=script&lang=js"
export * from "./ServiceProviderList.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderList.vue?vue&type=style&index=0&id=661012f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports